import { render } from "./ProjectSingle2.vue?vue&type=template&id=74d2c74b&scoped=true"
import script from "./ProjectSingle2.vue?vue&type=script&lang=js"
export * from "./ProjectSingle2.vue?vue&type=script&lang=js"

import "./ProjectSingle2.vue?vue&type=style&index=0&id=74d2c74b&scoped=true&lang=css"

import exportComponent from "G:\\vuejs-tailwindcss-portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d2c74b"]])

export default __exports__